// extracted by mini-css-extract-plugin
module.exports = {"auto":"Spinner_auto__2mxiV","ldsRing":"Spinner_ldsRing__2jpwk","sm":"Spinner_sm__1_Th-","md":"Spinner_md__caZ33","lg":"Spinner_lg__25hHc"};